module.exports = __webpack_public_path__ + "Tools-7ddbd66e.png";